import React from 'react';
import { Link } from 'gatsby';
import moment from 'moment';
import _ from 'lodash';

export const getPostsFromEdges = (postEdges) => {
  return postEdges.map(postEdge => {
    return {
      path: postEdge.node.fields.slug,
      tags: postEdge.node.frontmatter.tags,
      categories: postEdge.node.frontmatter.categories,
      image_url: postEdge.node.frontmatter.image_url,
      title: postEdge.node.frontmatter.title,
      description: postEdge.node.frontmatter.description,
      date: postEdge.node.fields.date,
      excerpt: postEdge.node.excerpt,
      timeToRead: postEdge.node.timeToRead,
      year: moment(postEdge.node.fields.date).get('year'),
    };
  });
};

export default class PostListing extends React.Component {
  getPostList() {
    const { postEdges } = this.props;
    const postList = getPostsFromEdges(postEdges);
    return _.groupBy(postList, 'year');
  }

  render() {
    const postsByYear = this.getPostList();
    const yearsSorted = Object.keys(postsByYear).sort((a, b) => {
      if (a > b) {
        return -1;
      }
      if (b > a) {
        return 1;
      }
      return 0;
    });
    return (
      <ul className="list-none p-0 m-0">
        {
          yearsSorted.map((year) => {
            const posts = postsByYear[year].map((post) => (
              <li className="py-1" key={post.path}>
                <div className="whitespace-no-wrap font-sans leading-snug text-base text-gray-700">
                  <span className="">
                    {moment(post.date).format('MMMM D')}
                  </span>
                </div>
                <div className="leading-normal">
                  <Link to={post.path}>{post.title}</Link>
                </div>
                <div className="flex justify-start whitespace-no-wrap font-sans leading-snug text-sm text-gray-600">
                  <span>
                    {post.timeToRead}
                    {' '}
                    min read
                  </span>
                </div>
              </li>
            ));
            return (
              <div key={year}>
                <h2>{year}</h2>
                <ul className="list-none p-0 m-0">
                  {posts}
                </ul>
              </div>
            );
          })
        }
      </ul>
    );
  }
}
